//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormAuxiliary,
    updateSubFormAuxiliary,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { Button } from '@carbon/react'

//// Carbon Icons
import { Add } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AddFormComponent = ({ digital_sub_name, sub_title }) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const max_form_iterations =
        settingsData?.['application']?.['max_form_iterations']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    // Handle Addition Of Forms
    const handleAddAdtNameForm = async () => {
        if (digital_name && !digital_sub_name) {
            if (
                formsData[digital_name].auxiliary.addtForms?.length <
                max_form_iterations?.length
            ) {
                const arr = formsData[digital_name].auxiliary.addtForms
                const addt =
                    formsData[digital_name].auxiliary.addtForms.length + 1
                const addtArr = [...arr, addt]
                dispatch(
                    updateFormAuxiliary({
                        digital_name: digital_name,
                        auxiliary: {
                            addtForms: addtArr,
                        },
                    })
                )
            }
        } else if (digital_name && digital_sub_name) {
            if (
                formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                    ?.addtForms?.length < max_form_iterations?.length
            ) {
                const arr =
                    formsData[digital_name][digital_sub_name].auxiliary
                        .addtForms
                const addt =
                    formsData[digital_name][digital_sub_name].auxiliary
                        .addtForms.length + 1
                const addtArr = [...arr, addt]
                dispatch(
                    updateSubFormAuxiliary({
                        digital_name: digital_name,
                        digital_sub_name: digital_sub_name,
                        auxiliary: {
                            addtForms: addtArr,
                        },
                    })
                )
            }
        }
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (digital_name === 'examination-history') {
        return (
            <>
                <nav className="half-width-button-with-icon-and-paragraph-group">
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <p>{sub_title}</p>
                    </div>
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="tertiary"
                            size="md"
                            onClick={handleAddAdtNameForm}
                            disabled={
                                formsData[digital_name].auxiliary.addtForms
                                    ?.length < max_form_iterations?.length
                                    ? false
                                    : true
                            }
                        >
                            Add Another Record - Examination History
                            <Add />
                        </Button>
                    </div>
                </nav>
            </>
        )
    } else if (digital_name === 'name-and-personal-details') {
        return (
            <>
                <nav className="half-width-button-with-icon-and-paragraph-group">
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <p>{sub_title}</p>
                    </div>
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="tertiary"
                            size="md"
                            onClick={handleAddAdtNameForm}
                            disabled={
                                formsData[digital_name].auxiliary.addtForms
                                    ?.length < max_form_iterations?.length
                                    ? false
                                    : true
                            }
                        >
                            Name(s) Previously Known By
                            <Add />
                        </Button>
                    </div>
                </nav>
            </>
        )
    } else if (digital_name && !digital_sub_name) {
        return (
            <>
                <nav className="half-width-button-with-icon-and-paragraph-group">
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <p>{sub_title}</p>
                    </div>
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="tertiary"
                            size="md"
                            onClick={handleAddAdtNameForm}
                            disabled={
                                formsData[digital_name].auxiliary.addtForms
                                    ?.length < max_form_iterations?.length
                                    ? false
                                    : true
                            }
                        >
                            Add
                            <Add />
                        </Button>
                    </div>
                </nav>
            </>
        )
    } else if (digital_name && digital_sub_name) {
        return (
            <>
                <nav className="half-width-button-with-icon-and-paragraph-group">
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <p>{sub_title}</p>
                    </div>
                    <div className="half-width-button-with-icon-and-paragraph-group-item">
                        <Button
                            className="fldoh-btn"
                            type="button"
                            kind="tertiary"
                            size="md"
                            onClick={handleAddAdtNameForm}
                            disabled={
                                formsData?.[digital_name]?.[digital_sub_name]
                                    ?.auxiliary?.addtForms?.length <
                                max_form_iterations?.length
                                    ? false
                                    : true
                            }
                        >
                            Add
                            <Add />
                        </Button>
                    </div>
                </nav>
            </>
        )
    }
}

export default AddFormComponent
